function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React from "react";
import classNames from "classnames";
import eapi from "@cbook/shared/utils/ExtensionAPI";
import eapi2 from "@cbook/shared/apiV2/ExtensionAPI";
import ChartProvider from "@cbook/shared/utils/extensionProviders/ChartProvider";
import CBookProvider from "@cbook/shared/utils/extensionProviders/CBookProvider";
import StoreProvider from "@cbook/shared/utils/extensionProviders/StoreProvider";
import SocialChartProvider from "@cbook/shared/utils/extensionProviders/SocialChartProvider";
import AccessibilityToolbar from "./AccessibilityToolbar";
import AppHeader from "../containers/AppHeader";
import AppFooter from "../containers/AppFooter";
import AppMenu from "../containers/AppMenu";
import AppModal from "../containers/AppModal";
import AppChartNavigation from "../containers/AppChartNavigation";
import AlertsApp from "../containers/AlertsApp";
import SkipToContent from "./SkipToContent";
import eventBus from "../utils/eventBus";
import PrintView from "../containers/PrintView";
import BonusMaterial from "../containers/BonusMaterial";
import SocialApp from "../containers/SocialApp";
import SocialNotes from "../containers/SocialNotesApp";
import DebugConsole from "../containers/DebugConsole";
import ChartRenderer from "../containers/ChartRenderer";
import QuickSlideNav from "../containers/QuickSlideNav";
import QuickFavourites from "../containers/QuickFavourites";
import CBookUtils from "../utils/CBookUtils";
import NotificationDialog from "../containers/NotificationDialog";
import ErrorBoundary from "../containers/ErrorBoundary";
import ExamStatus from "../containers/ExamStatus";
import tracker from "../utils/piwik";
import { AssetManagerBridge } from "../utils/BridgeUtils";
import { injectIntl } from "react-intl";
import { getBrowserInfo } from "../utils/getBrowserInfo";
import isEqual from "lodash/isEqual";
import { NotLoggedInError, NotAuthorizedError, DisclaimerNotEndorsedError } from "../utils/error";
import SocialRemote from "../utils/api/SocialRemote";
var App = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(App, _React_Component);
    var _super = _createSuper(App);
    function App(props) {
        _classCallCheck(this, App);
        var _this;
        _this = _super.call(this, props);
        _this.renderChart = function() {
            var uiVisibilityState = _this.props.uiVisibilityState;
            var locked = uiVisibilityState.menu || uiVisibilityState.activityCenter || uiVisibilityState.notes || uiVisibilityState.bonusMaterial || uiVisibilityState.print;
            return /*#__PURE__*/ React.createElement(ChartRenderer, {
                autoplay: !_this.props.isInitialChart,
                pause: locked,
                lock: locked
            });
        };
        _this.state = {
            isLoaded: false,
            isInitialChart: true,
            showModal: false,
            currentChart: null
        };
        _this.apiContext = window || {};
        return _this;
    }
    var _proto = App.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var _getBrowserInfo_browser;
        var _this_props = this.props, fetchContent = _this_props.fetchContent, goTo = _this_props.goTo, getKeyValStore = _this_props.getKeyValStore, setKeyVal = _this_props.setKeyVal, deleteKey = _this_props.deleteKey, fetchSocialChartData = _this_props.fetchSocialChartData, updateSocialChartData = _this_props.updateSocialChartData, cbookStatus = _this_props.cbookStatus, currentSlideStatus = _this_props.currentSlideStatus;
        eventBus.bind(window);
        eventBus.setScope("app");
        // Init Extension API v2. TODO REMOVE in Future release
        var ExtensionAPI = eapi.expose(this.apiContext).ExtensionAPI;
        CBookProvider.setDataGetter(function() {
            var _this_props = _this.props, cbook = _this_props.cbook, storyMode = _this_props.storyMode, student = _this_props.student;
            var _cbook = _objectSpread({}, cbook);
            if (student) {
                _cbook.student_id = student.id;
                _cbook.student_name = student.name;
            }
            return CBookProvider.DataStruct(_cbook, {
                isStoryModeActive: storyMode
            }, false);
        });
        var getContent = function(slide) {
            return _this.props.contents[slide.id] ? Promise.resolve(_this.props.contents[slide.id]) : CBookUtils.getChartContent(slide);
        };
        ChartProvider.setDataGetter(function() {
            var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var current = _this.props.currentSlide;
            var slide = _this.props.getSlide(options.chartId || current);
            var content = slide && _this.props.contents[slide.id];
            if (!content && slide && slide.id !== current) {
                fetchContent(slide.target_id, slide.target_type, slide.id);
            }
            return new Promise(function(resolve, reject) {
                var tries = 0;
                var _res = function() {
                    var _content = slide && _this.props.contents[slide.id];
                    if (slide && _content) {
                        tracker.trackEvent("ExtensionAPIv1/2 call", "chartContent", "ExtensionID: ".concat(_content.extension_id, ", SlideID: ").concat(slide.id));
                        resolve(ChartProvider.DataStruct(slide, _content || {}));
                    } else if (tries < 50) {
                        tries++;
                        setTimeout(_res, 200);
                    } else {
                        reject(new Error("Could not load Content"));
                    }
                };
                _res();
            });
        });
        ChartProvider.externAssetBridge = {
            requestClaim: AssetManagerBridge.requestClaim,
            releaseClaim: AssetManagerBridge.releaseClaim,
            indexClaims: AssetManagerBridge.indexClaims
        };
        ChartProvider.jumpToChart = function(id) {
            goTo(null, id, _this.props.currentSlide);
        };
        ChartProvider.jumpToChartLegacy = function(id) {
            goTo(id);
        };
        SocialChartProvider.setUserGetter(function() {
            return _this.props.session;
        });
        SocialChartProvider.setDataEndpoints(function() {
            var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return {
                socialChart: {
                    getter: function() {
                        var _options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                        return new Promise(function(resolve, reject) {
                            var chart = _this.props.getSlide(_options.chartId || _this.props.currentSlide) || _this.props.getSlide(_this.props.currentSlide);
                            if (!chart) {
                                reject(new Error("Could not find Slide"));
                            }
                            getContent(chart).then(function(data) {
                                var socialConfig = _this.props.socialConfig;
                                var session = _this.props.session;
                                var isLoggedIn = session && (!(socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.disclaimer.needs_endorsement) || (socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.disclaimer.needs_endorsement) && session.is_disclaimer_endorsed);
                                // if we are dealing with an extension
                                if (data.extension_id) {
                                    if (isLoggedIn) {
                                        SocialRemote.getPluginData(String(data.extension_id), chart === null || chart === void 0 ? void 0 : chart.id).then(resolve, reject);
                                    // if (chart) {
                                    //   fetchSocialChartData(chart.id, data.extension_id);
                                    // }
                                    } else {
                                        if (!session) {
                                            reject(new NotLoggedInError());
                                        } else if ((socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.disclaimer.needs_endorsement) && !session.is_disclaimer_endorsed) {
                                            reject(new DisclaimerNotEndorsedError());
                                        } else {
                                            reject(new NotAuthorizedError());
                                        }
                                    }
                                } else {
                                    reject(new Error("No Extension Chart"));
                                }
                            });
                        });
                    },
                    setter: function(data) {
                        var _options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        return getContent(_this.props.getSlide(_options.chartId || _this.props.currentSlide)).then(function(cont) {
                            return SocialRemote.savePluginData(String(cont.extension_id), _options.chartId ? _options.chartId : _this.props.currentSlide, JSON.stringify(data));
                        });
                    }
                },
                communityChart: {
                    getter: function() {
                        var _options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                        return new Promise(function(resolve, reject) {
                            var chart = _this.props.getSlide(_options.chartId || _this.props.currentSlide);
                            if (!chart) {
                                reject(new Error("Could not find Slide"));
                            }
                            getContent(chart).then(function(data) {
                                var socialConfig = _this.props.socialConfig;
                                var session = _this.props.session;
                                var isLoggedIn = session && (!(socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.disclaimer.needs_endorsement) || (socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.disclaimer.needs_endorsement) && session.is_disclaimer_endorsed);
                                if (isLoggedIn) {
                                    SocialRemote.getCommunityPluginData(String(data.extension_id), chart === null || chart === void 0 ? void 0 : chart.id).then(resolve, reject);
                                // this.props.fetchCommunityChartData(
                                //   chart.id,
                                //   data.extension_id,
                                // );
                                } else {
                                    if (!session) {
                                        reject(new NotLoggedInError());
                                    } else if ((socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.disclaimer.needs_endorsement) && !session.is_disclaimer_endorsed) {
                                        reject(new DisclaimerNotEndorsedError());
                                    } else {
                                        reject(new NotAuthorizedError());
                                    }
                                }
                            });
                        });
                    }
                }
            };
        });
        StoreProvider.setDataGetter(getKeyValStore);
        StoreProvider.setKeyVal = setKeyVal;
        StoreProvider.deleteKey = deleteKey;
        // Initialize APIv1
        ExtensionAPI.initialize([
            ChartProvider,
            CBookProvider,
            SocialChartProvider,
            StoreProvider
        ]);
        // Initialize Extensions APIv2
        eapi2.expose(this.apiContext, [
            ChartProvider,
            CBookProvider,
            SocialChartProvider,
            StoreProvider
        ]);
        document.body.classList.add("cbook-status-".concat(cbookStatus.replace(" ", "-")));
        document.body.classList.add("slide-status-".concat(currentSlideStatus.replace(" ", "-")));
        document.body.classList.add("browser-".concat((_getBrowserInfo_browser = getBrowserInfo().browser) === null || _getBrowserInfo_browser === void 0 ? void 0 : _getBrowserInfo_browser.replace(" ", "-")));
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        eventBus.unbind(window);
        // remove extension API v1
        eapi.remove(this.apiContext);
        // remove extension API v2
        eapi2.remove(this.apiContext);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this_props = this.props, cbook = _this_props.cbook, currentSlide = _this_props.currentSlide, contents = _this_props.contents, cbookStatus = _this_props.cbookStatus, currentSlideStatus = _this_props.currentSlideStatus, connections = _this_props.connections, getSlide = _this_props.getSlide;
        if (!isEqual(prevProps.cbook, cbook)) {
            CBookProvider.dispatch();
        }
        if (cbookStatus !== prevProps.cbookStatus) {
            document.body.classList.remove("cbook-status-".concat(prevProps.cbookStatus.replace(" ", "-")));
            document.body.classList.add("cbook-status-".concat(cbookStatus.replace(" ", "-")));
        }
        if (currentSlideStatus !== prevProps.currentSlideStatus) {
            document.body.classList.remove("slide-status-".concat(prevProps.currentSlideStatus.replace(" ", "-")));
            document.body.classList.add("slide-status-".concat(currentSlideStatus.replace(" ", "-")));
        }
        if (prevState.currentSlide !== currentSlide || !isEqual(contents, prevProps.contents)) {
            ChartProvider.dispatch();
            var slide = currentSlide ? getSlide(currentSlide) : null;
            if (slide) {
                var _slide_target_type_replace;
                var prevSlide = prevProps.currentSlide ? getSlide(prevProps.currentSlide) : null;
                if (prevSlide) {
                    var _prevSlide_target_type_replace;
                    document.body.classList.remove("slide-type-".concat((_prevSlide_target_type_replace = prevSlide.target_type.replace(" ", "-")) === null || _prevSlide_target_type_replace === void 0 ? void 0 : _prevSlide_target_type_replace.toLowerCase()));
                    document.body.classList.remove("slide-id-".concat(prevSlide.target_id));
                }
                document.body.classList.add("slide-type-".concat((_slide_target_type_replace = slide.target_type.replace(" ", "-")) === null || _slide_target_type_replace === void 0 ? void 0 : _slide_target_type_replace.toLowerCase()));
                document.body.classList.add("slide-id-".concat(slide.target_id));
            }
        }
        if ((connections === null || connections === void 0 ? void 0 : connections.diff) && !isEqual(prevProps.connections.diff, connections.diff)) {
            this._onConnectionChange(connections.diff);
        }
    };
    _proto.render = function render() {
        var _this_props = this.props, isLoading = _this_props.isLoading, uiVisibilityState = _this_props.uiVisibilityState, cbook = _this_props.cbook, completeable = _this_props.completeable, intl = _this_props.intl;
        var classes = classNames("book-wrapper", {
            "menu-is-visible": uiVisibilityState.menu,
            "a11y-modal-is-visible": uiVisibilityState.accessibilityToolbar,
            "chart-quick-nav-is-visible": uiVisibilityState.quickNav,
            "activities-are-visible": uiVisibilityState.activityCenter,
            "notes-are-visible": uiVisibilityState.notes,
            "bonus-material-is-visible": uiVisibilityState.bonusMaterial,
            "quick-favourites-is-visible": uiVisibilityState.quickFavourites,
            "do-not-track-chart": this.state.currentChart ? this.state.currentChart.do_not_track : false,
            "book-wrapper--is-loading": isLoading,
            "course-not-completeable": !completeable
        });
        var style = {};
        if (!!cbook && cbook.background_cover && cbook.background_cover.length) {
            style.backgroundImage = "url('".concat(encodeURI(cbook.background_cover), "')");
        }
        var showQuickFav = !!cbook && cbook.quick_nav;
        var shouldNavBeVisibleWithQuickFav = showQuickFav && cbook.quick_nav_hide_navigation ? !uiVisibilityState.quickFavourites : true;
        return /*#__PURE__*/ React.createElement("div", {
            className: "cbook-container"
        }, /*#__PURE__*/ React.createElement(SkipToContent, null), isLoading && /*#__PURE__*/ React.createElement("div", {
            className: "cbook-preloader"
        }), /*#__PURE__*/ React.createElement("div", {
            className: classes,
            style: style
        }, /*#__PURE__*/ React.createElement(AlertsApp, null), /*#__PURE__*/ React.createElement(ErrorBoundary, null, /*#__PURE__*/ React.createElement(AppHeader, null)), /*#__PURE__*/ React.createElement(AppMenu, null), /*#__PURE__*/ React.createElement(AccessibilityToolbar, null), /*#__PURE__*/ React.createElement(ErrorBoundary, null, /*#__PURE__*/ React.createElement("div", {
            className: "transitioner"
        }, /*#__PURE__*/ React.createElement(ExamStatus, null), uiVisibilityState.print ? /*#__PURE__*/ React.createElement(PrintView, null) : this.renderChart(), /*#__PURE__*/ React.createElement(AppModal, null))), /*#__PURE__*/ React.createElement(ErrorBoundary, {
            tiny: true
        }, /*#__PURE__*/ React.createElement(AppChartNavigation, {
            visible: !uiVisibilityState.menu && !uiVisibilityState.activityCenter && !uiVisibilityState.notes && !uiVisibilityState.bonusMaterial && !uiVisibilityState.modal && !uiVisibilityState.print && shouldNavBeVisibleWithQuickFav
        })), !isLoading && (cbook === null || cbook === void 0 ? void 0 : cbook.can_use_engagement_server) && /*#__PURE__*/ React.createElement(SocialApp, null), !isLoading && (cbook === null || cbook === void 0 ? void 0 : cbook.can_use_engagement_server) && /*#__PURE__*/ React.createElement(SocialNotes, null), !isLoading && /*#__PURE__*/ React.createElement(BonusMaterial, null), showQuickFav && !isLoading && /*#__PURE__*/ React.createElement(QuickFavourites, null), !isLoading && /*#__PURE__*/ React.createElement(QuickSlideNav, {
            visible: uiVisibilityState.quickNav
        }), /*#__PURE__*/ React.createElement(AppFooter, null)), /*#__PURE__*/ React.createElement(DebugConsole, null), /*#__PURE__*/ React.createElement(NotificationDialog, null));
    };
    _proto._onConnectionChange = function _onConnectionChange(change) {
        console.log("connection updated", change);
        var status = change.status, reason = change.reason;
        if (status === 303) {
            // HTTP Status 303 => see_other
            document.location.href = reason.headers.Location;
        }
    };
    return App;
}(React.Component);
export default injectIntl(App);
